import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

// Class component provides the actual error boundary behavior
class ErrorBoundaryClass extends Component<Props, State> {
  // Explicit declaration required: project has no @types/react, so Component<P,S> resolves as any
  declare props: Readonly<Props>;
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[ErrorBoundary] Yakalanmayan hata:', error, info.componentStack);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-black flex items-center justify-center p-6">
          <div className="bg-background-card border border-border-color/20 rounded-2xl p-8 max-w-md w-full text-center shadow-2xl shadow-black/50">
            <span className="material-symbols-outlined text-5xl text-accent-red mb-4 block">error</span>
            <h1 className="text-fg text-2xl font-black mb-2">Bir şeyler ters gitti</h1>
            <p className="text-text-secondary text-sm mb-6">
              Beklenmedik bir hata oluştu. Sayfayı yenileyerek tekrar deneyebilirsiniz.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-primary text-white font-bold px-6 py-3 rounded-xl hover:opacity-90 transition-opacity"
            >
              Sayfayı Yenile
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

// Function wrapper so TypeScript/JSX accepts children without @types/react
function ErrorBoundary({ children }: Props) {
  return React.createElement(ErrorBoundaryClass, { children });
}

export default ErrorBoundary;
